var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from '@emotion/styled';
import { getTrackerProps } from '../../../../common/tracking/getTrackerProps';
import { LocaleConsumer } from '../../../../common/providers/LocaleProvider';
import { Link } from '../../../../common/components/Link';
var List = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n  list-style: none;\n"], ["\n  margin: 0;\n  padding: 0;\n  list-style: none;\n"])));
var ListItem = styled.li(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &:not(:first-of-type) {\n    margin-top: 8px;\n  }\n"], ["\n  &:not(:first-of-type) {\n    margin-top: 8px;\n  }\n"])));
var MainBlock = function (_a) {
    var items = _a.items;
    return (React.createElement(LocaleConsumer, null, function (l10n) { return (React.createElement(List, null, items.map(function (item, index) { return (React.createElement(ListItem, { key: item.id },
        React.createElement(Link, __assign({}, getTrackerProps({ href: l10n.prefix.t(item.url) }, {
            event: 'headerTracking',
            eventData: {
                placement: 'userAccountIcon',
                labelIdentifier: item.text,
                listIndex: index,
                listLength: items.length,
            },
        })), l10n.t(item.text)))); }))); }));
};
var mainBlockItems = [
    {
        id: 'h24_my_overview',
        text: 'h24_my_overview',
        url: 'h24_my_overview_url',
    },
    {
        id: 'h24_my_orders',
        text: 'h24_my_orders',
        url: 'h24_my_orders_url',
    },
    {
        id: 'h24_my_customer_profile',
        text: 'h24_my_customer_profile',
        url: 'h24_my_customer_profile_url',
    },
    {
        id: 'h24_help_contact',
        text: 'h24_help_contact',
        url: 'h24_help_contact_url',
    },
];
MainBlock.defaultProps = {
    items: mainBlockItems,
};
export default MainBlock;
var templateObject_1, templateObject_2;
